export default __webpack_public_path__ + "static/media/logo.svg.feae6ca8.svg";